export class PlantsDropDown {
    plantId: number;
    plantName: string;

    /**
     * 
     * @param plantId 
     * @param plantName 
     */
    constructor(plantId: number, plantName: string) {
        this.plantId = plantId;
        this.plantName = plantName;
    }

}